import './style.scss'

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { map, filter, find } from 'lodash'
import logic from './logic'
import { bindShortcuts } from 'redux-shortcuts'

import Search from './Search'
// const { SHOW_ALL, SHOW_ACTIVE, SHOW_COMPLETED } = sceneLogic.constants

const initShortcuts = (dispatch) => {
  bindShortcuts(
    // Dispatch and prevent default behavior
    [['command+s', 'ctrl+s'], logic.actions.toggle, true]
  )(dispatch);
};

class SearchContainer extends Component {

  componentDidMount(){
    const { dispatch } = this.props;
    initShortcuts(dispatch);
  }

  render() {
    return (
      <Search />
    )
  }
}

export default connect()(SearchContainer)